export const SUPPORT_TICKET_CREATE_CACHE_KEY = 'createSupportTicket';

export const SUPPORT_ATTACHMENT_MAX_SIZE = 3 * 1024 * 1024;

export const SUPPORT_ATTACHMENT_ACCEPTED_TYPES = {
  'application/pdf': [ '.pdf' ],
  'image/png': [ '.png' ],
  'image/jpeg': [ '.jpeg', '.jpg' ],
  'image/gif': [ '.gif' ],
};
